import PropTypes from "prop-types";
import { Field } from 'formik'
import React from 'react'
import NipDisabled from "../NipInput/NipDisabled";
import NipInput from "../NipInput/NipInput";
import NipInputSession from "../NipInput/NipInputSession";
import NipSelect from "../NipInput/NipSelect";
import { opt2 } from "../../utils/Functions/Opt";

export default function FundTransferFields(props) {
    const {time_stamp, random_number} = props
    return (
        <div className="nip-form">
            <Field
                name="sendersFinancialInstitutionCode"
                placeholder="Enter Institution Code"
                label="Session ID"
                detail="This is made up of sender's institution code, date and time, and character unique number."
                title2="Date and time"
                value2={time_stamp}
                title3="Unique number"
                value3={random_number}
                component={NipInputSession}
            />
            <Field
                name="destinationInstitutionCode"
                label="Destination Code"
                component={NipDisabled}
            />
            <Field
                name="channelCode"
                label="Channel Code"
                component={NipDisabled}
            />
            <Field
                name="nameEnquiryRef"
                label="Name Enquiry Ref"
                component={NipDisabled}
            />
            <Field
                name="beneficiaryAccountName"
                label="Beneficiary Account Name"
                component={NipDisabled}
            />
            <Field
                name="beneficiaryAccountNumber"
                label="Beneficiary Account Number"
                component={NipDisabled}
            />
            <Field
                name="beneficiaryBankVerificationNumber"
                label="Beneficiary Bank Verification Number"
                component={NipDisabled}
            />
            <Field
                name="beneficiaryKYCLevel"
                label="Beneficiary KYC Level"
                component={NipDisabled}
            />
            <Field
                name="originatorAccountName"
                placeholder="Enter Account Name"
                label="Originator Account Name"
                component={NipInput}
            />
            <Field
                name="originatorAccountNumber"
                placeholder="Enter Account Number"
                label="Originator Account Number"
                component={NipInput}
            />
            <Field
                name="originatorBankVerificationNumber"
                placeholder="Enter BVN"
                label="Originator Bank Verification Number"
                component={NipInput}
            />
            <Field name="originatorKYCLevel">
                {(val) => (
                    <NipSelect
                        label="Originator KYC Level"
                        placeholder="Select KYC Level"
                        options={opt2}
                        {...val}
                    />
                )}
            </Field>
            <Field
                name="paymentReference"
                placeholder="Enter Payment Reference"
                label="Payment Reference"
                component={NipInput}
            />
            <Field
                name="narration"
                placeholder="Enter Narration"
                label="Narration"
                component={NipInput}
            />
            <Field
                name="transactionLocation"
                placeholder="Enter Transaction Location"
                label="Transaction Location"
                component={NipInput}
            />
            <Field
                name="amount"
                placeholder="Enter Amount"
                label="Amount"
                component={NipInput}
            />

        </div>
    )
}

FundTransferFields.propTypes = {
  random_number: PropTypes.any,
  time_stamp: PropTypes.any
}
